import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class EmailTemplateService extends Service {
	constructor(injector: Injector) {
		super("EmailTemplates", injector);
	}
}